import { render, staticRenderFns } from "./AdminStudentUpload.vue?vue&type=template&id=eaf3236e"
import script from "./AdminStudentUpload.vue?vue&type=script&lang=js"
export * from "./AdminStudentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports